import React from 'react';
import { useSelector } from 'react-redux';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import SuspenseFallback from 'components/routers/RouteHandler/SuspenseFallback';
import AppConfigError from 'containers/pages/error/AppConfigError';
import EnvironmentError from 'components/standard/Restrictions/RestrictionEnvironmentError';
import { selectors as officeIpSelectors } from 'modules/api/network/util/isOfficeIpModule';
import { selectors as whatismyipSelectors } from 'modules/api/utilities/info/whatismyipModule';
import { selectors as appConfigSelectors } from 'modules/appConfig';
import PropTypes from 'prop-types';

const Container = ({ children }) => (
	<Stack alignItems="center" justifyContent="center" height="100vh">
		{children}
	</Stack>
);

const AppConfigGate = ({ children }) => {
	const appConfig = useSelector(appConfigSelectors.getAppConfig);
	const isOfficeIp = useSelector(officeIpSelectors.getIsOfficeIp);
	const officeIpIsLoading = useSelector(officeIpSelectors.isLoading);
	const officeIpHasData = useSelector(officeIpSelectors.hasData);
	const whatismyipHasError = useSelector(whatismyipSelectors.hasError); // This will be defined if you're not on the cloud vpn.

	if (!appConfig)
		return (
			<Container>
				<AppConfigError />
			</Container>
		);

	// Nothing in this block happens in production, so let's not be too picky about the loader handling.
	if (!isOfficeIp && process.env.REACT_APP_CONFIG !== 'prod') {
		if ((officeIpIsLoading || !officeIpHasData) && !whatismyipHasError)
			return (
				<Container>
					<SuspenseFallback />
				</Container>
			);

		return (
			<Container>
				<EnvironmentError sx={{ flexGrow: 1, width: '100%' }} />
			</Container>
		);
	}

	return children;
};

AppConfigGate.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]).isRequired,
};

export default AppConfigGate;
